import { createQueryClient } from '@fireflyhealth/api'

/**
 * The application's singleton QueryClient.
 *
 * `app/`'s ApiProvider puts it on the React context; services import it directly to invalidate
 * cached queries after a mutation, which needs the client rather than a hook.
 */
export const queryClient = createQueryClient()
